import * as React from 'react';

import {PREVIEW_TYPE} from '../../../../chat-preview/consts';

import {ChatPreviewWrapper} from '../../chat-preview-wrapper';
import {useGetChatSettings} from '../../graphql/hooks/use-get-chat-settings';

import {VIEWS, ERROR_MESSAGE_CRAWLING} from '../consts';
import type {ChatOnboardingView} from '../consts';

import {CrawlingState} from './crawling-state';

type Props = {
    previewWebsiteUrl: string;
    isCrawling: boolean;
    isCrawlingErrored: boolean;
    setCurrentView: (view: ChatOnboardingView) => void;
    setErrorMessage: (error: string) => void;
    canEmbedInIframe?: boolean | null | undefined;
};

export function InteractivePreview(props: Props) {
    const {setCurrentView, setErrorMessage, isCrawlingErrored} = props;

    const {chatSettings} = useGetChatSettings();

    React.useEffect(() => {
        if (isCrawlingErrored) {
            setErrorMessage(ERROR_MESSAGE_CRAWLING);
            setCurrentView(VIEWS.YOUR_WEBSITE_VIEW);
        }
    }, [isCrawlingErrored, setErrorMessage, setCurrentView]);

    if (props.isCrawling) {
        return <CrawlingState domain={props.previewWebsiteUrl} />;
    }

    if (!chatSettings || !chatSettings.embedScript) {
        return null;
    }

    return (
        <ChatPreviewWrapper
            previewWebsiteUrl={props.previewWebsiteUrl}
            previewType={PREVIEW_TYPE.ONBOARDING}
            embedScript={chatSettings.embedScript}
            instanceId={NutshellFrontendSettings.instanceId}
            canEmbedInIframe={props.canEmbedInIframe}
            isOnboarding={true}
            isDevelopment={NutClientConfig.isDevelopment}
        />
    );
}
